import {
  CommonConfigComponent,
  IWidgetComponentProps,
} from '@framework/engine';
import { FormItem } from '@framework/form';
import { StyledDrawerCollapse } from '@framework/ui';
import { Collapse } from 'antd';
import { IMultiPreferenceWidget } from './IMultiPreferenceWidget';
import { MultiPreferenceOptionsInput } from './config/MultiPreferenceOptionsInput';

export interface IMultiPreferenceConfigComponentProps
  extends IWidgetComponentProps<IMultiPreferenceWidget> {}

export function MultiPreferenceConfigComponent(
  props: IMultiPreferenceConfigComponentProps,
) {
  return (
    <StyledDrawerCollapse defaultActiveKey={['general', 'options']} ghost>
      <Collapse.Panel header="Impostazioni Generali" key="general">
        <div>
          <CommonConfigComponent
            {...props}
            hideConfigPlaceholder
            hideConfigDefaultValue
          />
        </div>
      </Collapse.Panel>

      <Collapse.Panel header="Opzioni" key="options">
        <FormItem name="cascade" label="Opzioni delle preferenze">
          <MultiPreferenceOptionsInput />
        </FormItem>
      </Collapse.Panel>
    </StyledDrawerCollapse>
  );
}
